<div id="timePickerModal" class="modal is-touch is-short" [ngClass]="{'is-open': (isModalOpen | async)}">
  <div class="modal__content">
    <div id="lblTimePickerTitle" class="modal__header h2">
      Select a Time
    </div>

    <div class="modal__body flex">
      <!-- Hour Selector -->
      <div class="col-5">
        <div>
          <div id="lblTimePickerHourSelectorHeading" class="h4 semi-bold gray-62">Hours</div>
          @for (hours of hourRows; track trackItem($index, hours)) {
            <div class="row no-gutters center large-text mt1">
              @for (hour of hours; track trackItem($index, hour)) {
                <div id="btnTimePickerHour{{hour.value}}" (click)="setSelectedHour(hour)" class="col-3 py2 border-radius"
                  [ngClass]="{'bg-brand-200': isSelectedHour(hour)}">
                  {{hour.displayValue}}
                </div>
              }
            </div>
          }
        </div>
      </div>

      <!-- Minute Selector -->
      <div class="col-4 border-left border-right border-gray-91">
        <div class="px2 semi-bold">
          <div id="lblTimePickerMinuteSelectorHeading" class="h4 gray-62">Minutes</div>
          @for (minutes of minuteRows; track trackItem($index, minutes)) {
            <div class="row no-gutters center larger-text mt1">
              @for (minute of minutes; track trackItem($index, minute)) {
                <div id="btnTimePickerMinute{{minute.value}}" (click)="setSelectedMinute(minute)" class="col-6 py2 border-radius"
                  [ngClass]="{'bg-brand-200': isSelectedMinute(minute)}">
                  {{minute.displayValue}}
                </div>
              }
            </div>
          }
        </div>
      </div>

      <!-- Period (AM/PM) Selector -->
      <div class="col-3 flex align-center justify-content-center">
        <div class="pt2 pl4">
          @for (period of periodRows; track trackItem($index, period)) {
            <div class="center">
              <div (click)="setSelectedPeriod(period)" id="btnTimePickerPeriod{{period.value}}" class="inline-block py2 px4 border-radius large-text"
                [ngClass]="{'bg-brand-200': isSelectedPeriod(period)}">
                {{period.value}}
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="modal__footer">
      <div class="flex-auto">
        <button id="btnTimePickerCancel" class="btn btn--true-blue-inverse" (click)="onCancelButtonClicked($event)">Cancel</button>
      </div>
      <button id="btnTimePickerSave" class="btn btn--true-blue" (click)="onSaveButtonClicked($event)">Save</button>
    </div>
  </div>
</div>